import { UserAnswerConstants as Constants } from "../constants";

const initialState = {
  loading: false,
};

export function userAnswerReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.LOADING:
      return {
        ...state,
        loading: true,
      };

    case Constants.STORE_OR_UPDATE_MULTIPLE:
      return {
        ...state,
        loading: false,
      };

    case Constants.CHECK_USER_PROGRESS:
      return {
        ...state,
        loading: false,
      };

    case Constants.FAILED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
